"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructors_controller_1 = __importDefault(require("./instructors.controller"));
var instructors_html_1 = __importDefault(require("./instructors.html"));
var Policies_1 = require("../../../../../classes/Policies");
function getInstructors(UsersModel) {
    return UsersModel.getInstructors({ all: true, status: "Active" }).then(function (response) {
        return response.instructors;
    });
}
getInstructors.$inject = ["UsersModel"];
function getDrivesPolicy(PoliciesModel) {
    return PoliciesModel.getByID("drives").then(function (response) {
        return (0, Policies_1.createFromSinglePolicyAPIResponse)(response);
    });
}
getDrivesPolicy.$inject = ["PoliciesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.instructors", {
        url: "/instructors",
        controller: instructors_controller_1.default,
        controllerAs: "vm",
        template: instructors_html_1.default,
        resolve: {
            instructors: getInstructors,
            drivesPolicy: getDrivesPolicy,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.instructors", [])
    .config(config)
    .controller("AdminStudentInstructorsController", instructors_controller_1.default);
